module.exports = __webpack_public_path__ + "static/media/apartment8.610202f0.jpg";